import AbstractDeviceSetup from "../all/AbstractDeviceSetup";

class OperaDeviceSetup extends AbstractDeviceSetup {
  constructor() {
    super();
  }
}

export default OperaDeviceSetup;



// WEBPACK FOOTER //
// ./src/devices/opera/DeviceSetup.js